export const DEFAULT_AUTOREVIEW_COMMENT_UUIDS =
  '{d304a8f4-7cca-4258-822a-bc2c5ea5c85c},{bb44e4e9-9eaf-4451-b9a5-22098a4ba385},{45abaf40-2174-4af6-8974-b4ce040ee762},{507e7ee0-d609-4de1-a3c6-3d3a22516631},{b94f9246-4fc3-412c-9e62-5efc854463f1},{d5996e4f-b717-416f-be14-608b20faa397},{a61be2a5-3961-4cf4-8dc4-20389ea0290e},{b94f9246-4fc3-412c-9e62-5efc854463f1},{bdb9b735-a4cd-456e-9ce4-1b9be8bfdeb1},{2b7d52df-40a9-49c9-ac56-721695eb8bbf},{c0fd9bf5-29ec-4e9e-902c-95e936edd2be}';

export const isAutoreviewCommentUUID = (
  uuid: string,
  commentUuids = ''
): boolean => {
  const autoreviewUUIDs = commentUuids.split(',');
  return autoreviewUUIDs.includes(uuid);
};
